import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'

export const NVAlertsContext = createContext()

const defaultStyles = {
  success: { backgroundColor: 'var(--green-100)' },
  error: { backgroundColor: 'var(--red-100)' },
  info: { backgroundColor: 'var(--warning-color)' },
}

export const NVAlertsProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([])
  const [loading, setLoading] = useState(false)

  const showAlertLoader = () => setLoading(true)
  const hideAlertLoader = () => setLoading(false)

  const hideAlert = useCallback((id) => {
    setAlerts((prev) => prev.filter((a) => a.id !== id))
  }, [])

  const showAlert = useCallback(({ message, style = {}, children = null, type = 'success', icon = null }) => {
    const defaultIcons = {
      success: <CheckAnimationIcon />,
      error: <XCircleAnimatedIcon />,
      info: null,
    }

    setLoading(false)
    setAlerts((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type,
        message,
        style: { ...defaultStyles[type], ...style },
        icon: icon ?? defaultIcons[type],
        children,
      },
    ])
  }, [])

  const value = useMemo(
    () => ({
      alerts,
      showAlert,
      hideAlert,
      loading,
      showAlertLoader,
      hideAlertLoader,
    }),
    [alerts, loading, showAlert, hideAlert],
  )

  return <NVAlertsContext.Provider value={value}>{children}</NVAlertsContext.Provider>
}

export const useNVAlertsContext = () => useContext(NVAlertsContext)
